import sharedModule from '../../shared.module';

export default sharedModule.factory(
    'configProvider',
    ($q, $sessionStorage, systemApiService) => {
        return {
            getConfigurations
        };

        function getConfigurations() {
            if ($sessionStorage.configs) {
                return $q.resolve($sessionStorage.configs);
            }
            var deferred = $q.defer();
            systemApiService.getConfigurations().then(
                data => {
                    $sessionStorage.configs = data;
                    deferred.resolve(data);
                },
                data => deferred.reject(data)
            );
            return deferred.promise;
        }
    }
);



// WEBPACK FOOTER //
// ./modules/shared/services/config/configProvider.service.js